import React from "react";
import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

// Material Symbols ligature for "groups" (rounded)
export const GroupsIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props} code={'groups'} />
    );
}
